var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 4.5A1.5 1.5 0 0 1 6.5 3h4.249a1.5 1.5 0 0 1 .251.021V5a1.5 1.5 0 0 0 1.5 1.5h2.444q.056.197.056.408V15.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 5 15.5zm9.17 1L12 3.602V5a.5.5 0 0 0 .5.5zM6.5 2A2.5 2.5 0 0 0 4 4.5v11A2.5 2.5 0 0 0 6.5 18h7a2.5 2.5 0 0 0 2.5-2.5V6.908a2.5 2.5 0 0 0-.854-1.882L12.395 2.62A2.5 2.5 0 0 0 10.749 2zm11 5a.5.5 0 0 1 .5.5v9a3.5 3.5 0 0 1-3.5 3.5h-8a.5.5 0 0 1 0-1h8a2.5 2.5 0 0 0 2.5-2.5v-9a.5.5 0 0 1 .5-.5M20 9.5a.5.5 0 0 0-1 0v8a3.5 3.5 0 0 1-3.5 3.5h-7a.5.5 0 0 0 0 1h7a4.5 4.5 0 0 0 4.5-4.5z",
    clipRule: "evenodd"
  })));
});
const SvgFiles = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFiles);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01IDQuNUM1IDMuNjcxNTcgNS42NzE1NyAzIDYuNSAzSDEwLjc0ODVDMTAuODMzMyAzIDEwLjkxNzQgMy4wMDcxOCAxMSAzLjAyMTIzVjVDMTEgNS44Mjg0MyAxMS42NzE2IDYuNSAxMi41IDYuNUgxNC45NDM2QzE0Ljk4MDcgNi42MzEzMiAxNSA2Ljc2ODM0IDE1IDYuOTA3NTRWMTUuNUMxNSAxNi4zMjg0IDE0LjMyODQgMTcgMTMuNSAxN0g2LjVDNS42NzE1NyAxNyA1IDE2LjMyODQgNSAxNS41VjQuNVpNMTQuMTY5MyA1LjVMMTIgMy42MDE4OFY1QzEyIDUuMjc2MTQgMTIuMjIzOSA1LjUgMTIuNSA1LjVIMTQuMTY5M1pNNi41IDJDNS4xMTkyOSAyIDQgMy4xMTkyOSA0IDQuNVYxNS41QzQgMTYuODgwNyA1LjExOTI5IDE4IDYuNSAxOEgxMy41QzE0Ljg4MDcgMTggMTYgMTYuODgwNyAxNiAxNS41VjYuOTA3NTRDMTYgNi4xODY2MyAxNS42ODg4IDUuNTAwODEgMTUuMTQ2MyA1LjAyNjA5TDEyLjM5NDggMi42MTg1NkMxMS45MzkxIDIuMjE5NzkgMTEuMzU0MSAyIDEwLjc0ODUgMkg2LjVaTTE3LjUgN0MxNy43NzYxIDcgMTggNy4yMjM4NiAxOCA3LjVWMTYuNUMxOCAxOC40MzMgMTYuNDMzIDIwIDE0LjUgMjBINi41QzYuMjIzODYgMjAgNiAxOS43NzYxIDYgMTkuNUM2IDE5LjIyMzkgNi4yMjM4NiAxOSA2LjUgMTlIMTQuNUMxNS44ODA3IDE5IDE3IDE3Ljg4MDcgMTcgMTYuNVY3LjVDMTcgNy4yMjM4NiAxNy4yMjM5IDcgMTcuNSA3Wk0yMCA5LjVDMjAgOS4yMjM4NiAxOS43NzYxIDkgMTkuNSA5QzE5LjIyMzkgOSAxOSA5LjIyMzg2IDE5IDkuNVYxNy41QzE5IDE5LjQzMyAxNy40MzMgMjEgMTUuNSAyMUg4LjVDOC4yMjM4NiAyMSA4IDIxLjIyMzkgOCAyMS41QzggMjEuNzc2MSA4LjIyMzg2IDIyIDguNSAyMkgxNS41QzE3Ljk4NTMgMjIgMjAgMTkuOTg1MyAyMCAxNy41VjkuNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";